import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

function ResetPasswordModal({ onClose }) {
  const [newPassword, setNewPassword] = useState("");

  const handleSubmit = async () => {
    const email = localStorage.getItem("email");
    console.log("Email iz localStorage:", email);  // dodaj to

    // Preveri, ali email obstaja
    if (!email) {
      toast.error("Email ni na voljo.");
      return;
    }

    // Preveri, ali je geslo dovolj dolgo
    if (!newPassword || newPassword.length < 6) {
      toast.error("Geslo mora imeti vsaj 6 znakov.");
      return;
    }

    try {
      await axios.put(
        "https://fnm-backend.aibc-robotics.com/reset-password",
        {
          email: email,
          new_password: newPassword,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Email:", email, "Novo geslo:", newPassword);
      toast.success("Geslo je bilo uspešno posodobljeno.");
      onClose();
    } catch (err) {
      console.error("Napaka pri posodobitvi gesla:", err.response?.data || err.message);
      toast.error("Napaka pri spremembi gesla: " + (err.response?.data?.detail || "Neznana napaka."));
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white p-6 rounded-xl shadow-lg space-y-4 w-full max-w-md"
      >
        <h2 className="text-xl font-semibold text-gray-800">Spremeni geslo</h2>
        <input
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          placeholder="Novo geslo"
          className="w-full border border-gray-300 p-2 rounded"
        />
        <div className="flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 hover:underline"
          >
            Prekliči
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Shrani geslo
          </button>
        </div>
      </div>
    </div>
  );
}

export default ResetPasswordModal;
